import styled from "styled-components";
import bg1 from "./assets/Graphics/bg1.png";
import bg2 from "./assets/Graphics/bg2.png";
import bg3 from "./assets/Graphics/bg3.png";
import bg4 from "./assets/Graphics/bg4.png";
import bg6 from "./assets/Graphics/bg6.png";
import bg8 from "./assets/Graphics/bg8.png";

export const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;

  /* background-color: red; */
`;
export const SingleCard = styled.div`
  display: flex;
  align-items: center;
  margin: 400px 0;
`;

export const Section1 = styled.h2`
  /* border: 1px solid #000; */
  border-radius: 10px;
  font-size: clamp(18px, 2.5vw, 5em);
  background-color: #ddb95e55;
  font-family: Georgia;
  flex: 0.8 1 200px;
  padding: 20px;
  text-transform: capitalize;
  height: 250px;
`;
export const Section2 = styled.ul`
  flex: 4 0 200px;
  /* background-color: red; */
  height: 250px;
  width: auto;

  list-style: none;
  display: flex;
  flex-direction: column;
  padding-left: 5px;
  justify-content: space-between;
  /* background-color: green; */
  /* height: 100%; */
  margin: 0 5px;

  li {
    display: flex;
    /* background-color: bisque; */
    border-radius: 5px;
    padding: 0.9rem 5px;
    align-items: center;
    /* text-align: end; */
    text-transform: capitalize;
    /* font-size: 1.1rem; */
    align-items: center;

    p {
    }

    span {
      font-size: clamp(14px, 1.3vw, 3em);
      font-weight: 900;
    }

    svg {
      /* background-color: green; */
    }
  }

  li span {
    /* margin-left: 10px; */
    align-self: center;
    color: #333;
    font-weight: bold;
  }
`;
export const Section3 = styled.div`
  width: 200px;
  height: auto;
  /* background-color: cadetblue; */
  flex: 0.5 0 200px;

  img {
    width: 90%;
    height: auto;
  }
`;
